export const transition = { 
    duration: .5, 
    ease: [.56, .03, .12, 1.04]
};

export const variants = {
    initial1: {
        width: '100%'
    },
    animate1: {
        width: '50%',
        backgroundColor: '#999'
    },
    initial2: { 
        left: '100%'
    },
    animate2: {
        left: '50%'
    },
}